export default __webpack_public_path__ + "images/98216cc2fd56ca6a7b5691f93dec5667.svg";